import React, { useState, useEffect } from "react";
import closeSvg from "../../assets/images/uncheck.svg";
import PreviewFrameEdit from "../PreviewFrameEdit";
import {
  SlIcon,
  SlInput,
  SlOption,
  SlSelect,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router";
import api from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {
  appCategoryNames,
  BrandsTypes as BrandsTypesOriginal,
  formatSpentValue,
  genderNames,
  langNames,
  languageOptions,
  osNames,
  slotOptions,
  slotPositions,
} from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import ErrorsReport from "./ErrorsReport";
import ScrollContainer from "react-indiana-drag-scroll";
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const year = yesterday.getFullYear();
const month = String(yesterday.getMonth() + 1).padStart(2, "0"); // Months are zero-based
const day = String(yesterday.getDate()).padStart(2, "0");
const BrandsTypes = [...BrandsTypesOriginal]

const cutoff_restrict_lang_ids = [-1,1,2]

const formattedDate = `${year}-${month}-${day}`;
export const InventoryContext = React.createContext();
function Inventory() {
  const [dateFilter, setDateFilter] = useState(formattedDate);
  const [initialRender, setInitialRender] = useState(true);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [adsdata, setAdsData] = useState([]);
  const [netPosView, setNetPosView] = useState(null);
  const [showAdPositions, setShowAdPositions] = useState(true);
  const [cardView, setCardView] = useState("all"); // "all" | "slot" | "others"
  const [languages, setLanguauges] = useState(["tel", "tam", "other"]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(1);
  const [selectedDistrict, setselectedDistrict] = useState(-1);
  const [preview, setPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(-1);
  const [errorCodewiseStats, setErrorCodewiseStats] = useState(null);
  const [missingUsersCounts, setMissingUsersCounts] = useState(null);
  const [isMissingUsersCountsLoader, setIsMissingUsersCountsLoader] = useState(false);
  const [dfpInternalData, setDFPInternalData] = useState([])
  const [dfpNofillOtherData, setDFPNofillOtherData] = useState([]);
  const [dfpotherErrorPreviewIndex, setDFPOtherErrorPreviewIndex] = useState(-1);
  const [dfpotherErrorPreviewData, setDFPOtherErrorPreviewData] = useState(null);
  const navigate = useNavigate();
  const [adFilterPositions, setAdFilterPositions] = useState([]);
  const [showErrorsReport, setShowErrorsReport] = useState(false);
  const getdata = async () => {
    setLoader(true);
    try {
      let res = await api({
        url: "/inventory/get-data",
        method: "POST",
        responseType: "json",
        data: {
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setData(res?.data?.result);
        let tempAdFilterPositions = selectedDistrict !== -1 ? adFilterPositions : res?.data?.slot_positions;  // if language level then use the positions from the api else use the positions already filtered
        if( selectedDistrict === -1 && cutoff_restrict_lang_ids.includes(selectedLanguage) ){ // if language level and cutoff restrict lang ids then filter the positions
          tempAdFilterPositions = tempAdFilterPositions.filter((item) => {
            let net_stats = res?.data?.result?.find((i) => i.position === item)?.net_stats || [];
            if( (net_stats.find((i) => i.ad_type === "request")?.count || 0) < 1000) return false;
            return true;
          });
        }
        if(showAdPositions){
          setFilteredData(res?.data?.result.filter((item) => {
            return tempAdFilterPositions.includes(item.position);
          }));
        }
        else {
          setFilteredData(res?.data?.result);
        }
        setAdFilterPositions(tempAdFilterPositions?.length > 0 ? tempAdFilterPositions : slotPositions);
      } else {
        // if (res.data.code === 400)
        //   Toast("error", `Please Select Date On or Below ${formattedDate} `);
        // else
         Toast("error", res.data?.message);
        setData([]);
      }
      setLoader(false);
      setInitialRender(false);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const fetchPreview = async (data) => {
    try {
      let res = await api({
        url: "/inventory/get-preview",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: data.campaign_id,
        },
      });
      if (res.code === 200) {
        setPreview(res?.data);
        setShowPreview(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getdata();
    getMissingUserCounts();
  }, []);
  useEffect(() => {
    // setShowAdPositions(false);
    setErrorCodewiseStats(null);
    setNetPosView(null);
    setMissingUsersCounts(null);
    if (!initialRender){
      getdata();
      getMissingUserCounts();
    }
  }, [dateFilter, selectedLanguage, selectedDistrict]);

  const fetchAdsData = async (body) => {
    try {
      let res = await api({
        url: "/inventory/get-team-campaigns-data",
        method: "POST",
        responseType: "json",
        data: {
          ...body,
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setAdsData(res?.data);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const fetchDFPInternalData = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-dfp-internal-data",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (res.code === 200) {
        setDFPInternalData(res?.data);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ fetchDFPInternalData", error);
    }    
  }

  const fetchDFPNofillOtherData = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-dfp-nofillother-data",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (res.code === 200) {
        setDFPNofillOtherData({lang_id: selectedLanguage, position: body.position, ad_type: body.error_type === 'no_fill' ? 'No Fill' : 'Other Errors', data: res?.data});
      } else {
        Toast("error", res.message);
      }
    }
    catch (error) {
      console.error("Error @ fetchDFPNofillOtherData", error);
    }
  }

  const getNetadcodeWiseStats = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-netadcode-stats",
        method: "POST",
        responseType: "json",
        data: {...body, 
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setNetPosView({lang_id: selectedLanguage, position: body.position, ad_type: body.ad_type, data: res?.data});
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ getNetadcodeWiseStats", error)
    }
  }

  const getNoFillOtherWiseStats = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-nofillother-stats",
        method: "POST",
        responseType: "json",
        data: {...body, 
          date: dateFilter,
          lang_id: selectedLanguage,
          district_id: selectedDistrict,
        },
      });
      if (res.code === 200) {
        setNetPosView({lang_id: selectedLanguage, position: body.position, ad_type: body.error_type === 'no_fill' ? 'No Fill' : 'Other Errors', data: res?.data});
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error("Error @ getNetadcodeWiseStats", error)
    }
  }
  const onShowAdPositionsChange = () => {
    if (showAdPositions) {
      setFilteredData(data.filter((item) => {
        return adFilterPositions.includes(item.position);
      }));
    } else {
      setFilteredData(data);
    }
  }
  useEffect(() => {
    onShowAdPositionsChange();
  }, [showAdPositions]);

  const handleLanguage = (e) => {
    let value = e.target.value;
    setselectedDistrict(-1)
    setSelectedLanguage(+value);
  };
  const fetchActualDistrict = async (lang_id) => {
    try {
      let res = await api({
        url: "/location/get-actual-districts",
        method: "POST",
        responseType: "json",
        data: { lang_id },
      });
      if (res.code === 200) {
        setDistrictOptions(res.data);
      }
    } catch (error) {
      console.error("Error @ fetchActualDistrict", error);
    }
  };

  const handleDistrict = (e) => {
    setselectedDistrict(+e.target.value);
  };
  useEffect(() => {
    fetchActualDistrict(selectedLanguage);
  }, [selectedLanguage]);

  const fetchErrorCodewiseStats = async (body) => {
    try {
      let data = await api({
        url: "/inventory/get-error-code-wise-stats",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (data.code === 200) {
        setErrorCodewiseStats(data.data);
      }
    } catch (error) {
      console.error("Error @ fetchErrorCodewiseStats", error);
    }
  }

  const getMissingUserCounts = async(body) => {
    try {
      setIsMissingUsersCountsLoader(true);
      let data = await api({
        url: "/inventory/get-missing-user-count",
        method: "POST",
        responseType: "json",
        data: {date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (data.code === 200) {
        setMissingUsersCounts(data.data);
      } else {
        console.error("Error @ getMissingusersCount",data.data?.message);
      }
      setIsMissingUsersCountsLoader(false);
    } catch (error) {
      console.error("Error @ getMissingUserCounts", error);
    }
  }

  const fetchDFPOtherErrorWiseStats = async(body) => {
    try {
      let res = await api({
        url: "/inventory/get-dfp-other-error-wise-stats",
        method: "POST",
        responseType: "json",
        data: {...body, date: dateFilter, lang_id: selectedLanguage, district_id: selectedDistrict},
      });
      if (res.code === 200) {
        setDFPOtherErrorPreviewData(res?.data);
      } else {
        Toast("error", res.data?.message || res.message || "Failed to fetch other error wise stats");
      }
    } catch (error) {
      console.error("Error @ fetchOtherErrorWiseStats", error);
    }
  }

  // Distinct backfill companies across all visible positions, used to render one column per company.
  const backfillCompanies = (() => {
    const map = new Map();
    for (const item of filteredData) {
      for (const bf of item.backfill_stats || []) {
        if (!map.has(bf.company_id)) {
          map.set(bf.company_id, bf.company_name?.trim() || `Company ${bf.company_id}`);
        }
      }
    }
    return Array.from(map, ([company_id, company_name]) => ({ company_id, company_name }));
  })();

  // Only show source columns that have at least one non-zero impression
  // somewhere across the visible positions/slots. While there is no data yet
  // (loading / empty), fall back to the full list so the header looks normal.
  const displayBrands = (() => {
    if (!filteredData.length) return BrandsTypes;
    return BrandsTypes.filter((brand) =>
      filteredData.some((item) =>
        (item.team_stats || []).flat().some(
          (i) => +i.new_user_type === +brand.value && (+i.imprs || 0) > 0
        )
      )
    );
  })();
  const heatCols = `34px repeat(${displayBrands.length}, minmax(0, 1fr)) 62px`;
  const srcCols = `150px 34px repeat(${displayBrands.length}, minmax(0, 1fr)) 62px`;

  // ----- Redesign helpers -----
  const HUE = 262;
  // Convey fill intensity through the number's typography instead of a colored
  // background: higher share → larger, bolder, darker text.
  const heatText = (pct) => {
    const t = pct <= 0 ? 0 : Math.min(1, 0.16 + pct / 38);
    return {
      size: +(11 + t * 5).toFixed(1), // 11 → 16px
      weight: t > 0.66 ? 700 : t > 0.33 ? 600 : 500,
      color: `oklch(${(0.52 - t * 0.24).toFixed(3)} ${(0.02 + t * 0.12).toFixed(3)} ${HUE})`,
    };
  };
  const pctOf = (val, total) =>
    total ? (((+val || 0) / total) * 100).toFixed(1) : "0";

  // Per-position derived numbers
  const derive = (item) => {
    const total = +item.imprs || 0;
    const team_stats = item.team_stats || [[], [], []];
    const backfill = (item.backfill_stats || []).reduce((a, i) => a + (+i.imprs || 0), 0);
    const dfp_imprs = +item.dfp_imprs || 0;
    const dfp_reqs = +item.dfp_reqs || 0;
    const dfp_no_fill = +item.dfp_no_fill_err_count || 0;
    const dfp_other = +item.dfp_other_err_count || 0;
    const net_stats = item.net_stats || [];
    const net_displays = net_stats.find((i) => i.ad_type === "display")?.count || 0;
    const net_requests = net_stats.find((i) => i.ad_type === "request")?.count || 0;
    const net_responses = net_stats.find((i) => i.ad_type === "response")?.count || 0;
    const net_no_fill = +item.net_no_fill_err_count || 0;
    const net_other = +item.net_other_err_count || 0;
    const net_errors = net_stats.find((i) => i.ad_type === "error")?.count || 0;
    const ad_partner = +item.ad_partner_stats || 0;
    const widget = +item.widget_imprs || 0;
    const classified = +item.classified_imprs || 0;
    let direct = 0;
    for (const brand of BrandsTypes) {
      direct += +team_stats.flat().filter((i) => +i.new_user_type === +brand.value)
        .reduce((a, i) => a + (+i.imprs || 0), 0);
    }
    const occupied = direct + +net_displays + dfp_imprs + backfill + widget + classified;
    const unoccupied = total - occupied;
    const occPct = total ? (occupied / total) * 100 : 0;
    return {
      total, team_stats, backfill, dfp_imprs, dfp_reqs, dfp_no_fill, dfp_other,
      net_displays, net_requests, net_responses, net_no_fill, net_other, net_errors,
      ad_partner, widget, classified, direct, occupied, unoccupied, occPct,
    };
  };

  // Grand totals across all visible positions (KPI strip + bottom card)
  const grand = (() => {
    const g = {
      total: 0, backfill: 0, direct: 0, net_displays: 0, dfp_imprs: 0, widget: 0, classified: 0,
      net_no_fill: 0, dfp_no_fill: 0, net_other: 0, dfp_other: 0,
      dfp_reqs: 0, net_requests: 0, net_responses: 0, ad_partner: 0,
      brandTotals: {}, backfillByCompany: {},
    };
    for (const item of filteredData) {
      const d = derive(item);
      g.total += d.total;
      g.backfill += d.backfill;
      g.direct += d.direct;
      g.net_displays += +d.net_displays;
      g.dfp_imprs += d.dfp_imprs;
      g.widget += d.widget;
      g.classified += d.classified;
      g.net_no_fill += d.net_no_fill;
      g.dfp_no_fill += d.dfp_no_fill;
      g.net_other += d.net_other;
      g.dfp_other += d.dfp_other;
      g.dfp_reqs += d.dfp_reqs;
      g.net_requests += +d.net_requests;
      g.net_responses += +d.net_responses;
      g.ad_partner += d.ad_partner;
      for (const brand of BrandsTypes) {
        g.brandTotals[brand.value] =
          (g.brandTotals[brand.value] || 0) +
          (+d.team_stats.flat().filter((i) => +i.new_user_type === +brand.value)
            .reduce((a, i) => a + (+i.imprs || 0), 0));
      }
      for (const bf of item.backfill_stats || []) {
        g.backfillByCompany[bf.company_id] =
          (g.backfillByCompany[bf.company_id] || 0) + (+bf.imprs || 0);
      }
    }
    g.occupied = g.direct + g.net_displays + g.dfp_imprs + g.backfill + g.widget + g.classified;
    g.unoccupied = g.total - g.occupied;
    g.occPct = g.total ? ((g.occupied / g.total) * 100).toFixed(1) : "0";
    g.unoccPct = g.total ? ((g.unoccupied / g.total) * 100).toFixed(1) : "0";
    return g;
  })();

  return (
    <div className="inventory inv2">

      {/* Top bar */}
      <div className="inv2-topbar">
        <div className="flex items-baseline gap-2">
          <span className="inv2-title">Inventory</span>
          <span className="mono" style={{ fontSize: 12.5, color: "oklch(0.6 0.02 260)" }}>{dateFilter}</span>
        </div>
        <div style={{ flex: 1 }}></div>
        <SlSelect value={"" + selectedLanguage} onSlChange={handleLanguage}>
          <SlOption value={-1}>All</SlOption>
          {languageOptions.map((item) => {
            return <SlOption value={item.value}>{item.label}</SlOption>;
          })}
        </SlSelect>
        <SlSelect value={"" + selectedDistrict} onSlChange={handleDistrict}>
          <SlOption value={-1}>All</SlOption>
          <SlOption value={0}>Others</SlOption>
          {districtOptions.map((item) => {
            return <SlOption value={item.value}>{item.label}</SlOption>;
          })}
        </SlSelect>
        <div className="inv2-seg">
          {[["all", "All"], ["slot", "Slot wise"], ["others", "Others"]].map(([v, l]) => (
            <button key={v} className={cardView === v ? "active" : ""} onClick={() => setCardView(v)}>{l}</button>
          ))}
        </div>
        <span
          className={`inv2-toggle ${showAdPositions ? "on" : ""}`}
          onClick={() => setShowAdPositions((prev) => !prev)}
        >
          <span className="box"></span>Show Ad Positions
        </span>
        <SlInput
          size="small"
          type="date"
          placeholder="Date"
          onSlInput={(e) => {
            setDateFilter(e.target.value);
          }}
          value={dateFilter}
          max={formattedDate}
        />
        <span
          className={`inv2-toggle ${showErrorsReport ? "on" : ""}`}
          onClick={() => setShowErrorsReport((prev) => !prev)}
        >
          <span className="box"></span>Errors Report
        </span>
      </div>

      {showErrorsReport && (
        <ErrorsReport
          dateFilter={dateFilter}
          selectedLanguage={selectedLanguage}
          selectedDistrict={selectedDistrict}
        />
      )}

      {/* display: contents keeps the layout identical; the inventory view stays mounted while hidden */}
      <div style={{ display: showErrorsReport ? "none" : "contents" }}>

      {/* KPI strip */}
      <div className="inv2-kpis">
        <div className="kpi">
          <div className="k-label">Total Requests</div>
          <div className="k-val mono" title={grand.total}>{formatSpentValue(grand.total)}</div>
        </div>
        <div className="kpi green">
          <div className="k-label">Occupancy Rate</div>
          <div className="k-sub">
            <span className="mono" style={{ fontSize: 22, fontWeight: 700, color: "oklch(0.5 0.13 155)" }}>{grand.occPct}%</span>
            <span className="mono" style={{ fontSize: 12.5, color: "oklch(0.55 0.06 155)" }} title={grand.occupied}>{formatSpentValue(grand.occupied)}</span>
          </div>
        </div>
        <div className="kpi amber">
          <div className="k-label">Unoccupied</div>
          <div className="k-sub">
            <span className="mono" style={{ fontSize: 22, fontWeight: 700, color: "oklch(0.58 0.15 45)" }}>{grand.unoccPct}%</span>
            <span className="mono" style={{ fontSize: 12.5, color: "oklch(0.6 0.08 45)" }} title={grand.unoccupied}>{formatSpentValue(grand.unoccupied)}</span>
          </div>
        </div>
        <div className="kpi red">
          <div className="k-label">Requests Missing</div>
          {isMissingUsersCountsLoader ? (
            <div className="bg-red-200 rounded animate-pulse h-5 w-20 mt-1"></div>
          ) : (
            <div className="mono" style={{ display: "flex", gap: 10, marginTop: 3 }}>
              <span style={{ fontSize: 15, fontWeight: 600, color: "oklch(0.55 0.18 20)" }} title={missingUsersCounts?.on_block_count || 0}>{formatSpentValue(missingUsersCounts?.on_block_count || 0)}<span style={{ fontSize: 10.5, color: "oklch(0.6 0.05 20)", fontWeight: 400 }}> on</span></span>
              <span style={{ fontSize: 15, fontWeight: 600, color: "oklch(0.62 0.12 40)" }} title={missingUsersCounts?.till_block_count || 0}>{formatSpentValue(missingUsersCounts?.till_block_count || 0)}<span style={{ fontSize: 10.5, color: "oklch(0.6 0.04 40)", fontWeight: 400 }}> till</span></span>
            </div>
          )}
        </div>
        <div className="kpi red">
          <div className="k-label">Display Missing</div>
          {isMissingUsersCountsLoader ? (
            <div className="bg-red-200 rounded animate-pulse h-5 w-20 mt-1"></div>
          ) : (
            <div className="mono" style={{ display: "flex", gap: 10, marginTop: 3 }}>
              <span style={{ fontSize: 15, fontWeight: 600, color: "oklch(0.55 0.18 20)" }} title={missingUsersCounts?.on_miss_count || 0}>{formatSpentValue(missingUsersCounts?.on_miss_count || 0)}<span style={{ fontSize: 10.5, color: "oklch(0.6 0.05 20)", fontWeight: 400 }}> on</span></span>
              <span style={{ fontSize: 15, fontWeight: 600, color: "oklch(0.62 0.12 40)" }} title={missingUsersCounts?.till_miss_count || 0}>{formatSpentValue(missingUsersCounts?.till_miss_count || 0)}<span style={{ fontSize: 10.5, color: "oklch(0.6 0.04 40)", fontWeight: 400 }}> till</span></span>
            </div>
          )}
        </div>
        <div className="kpi">
          <div className="k-label">GAM No-Fills</div>
          <div className="k-val mono" style={{ color: "oklch(0.58 0.13 45)" }} title={grand.net_no_fill}>{formatSpentValue(grand.net_no_fill)}</div>
        </div>
        <div className="kpi">
          <div className="k-label">DFP No-Fill</div>
          <div className="k-val mono" style={{ color: "oklch(0.58 0.13 45)" }} title={grand.dfp_no_fill}>{formatSpentValue(grand.dfp_no_fill)}</div>
        </div>
        <div className="kpi">
          <div className="k-label">Backfill</div>
          <div className="k-val mono" style={{ color: "oklch(0.5 0.1 300)" }} title={grand.backfill}>{formatSpentValue(grand.backfill)}</div>
        </div>
      </div>

      {/* section label + legend */}
      {cardView !== "others" && (
        <div className="inv2-section">
          <div className="lbl">DIRECT FILL BY SLOT &amp; SOURCE</div>
          <div className="rule"></div>
          <div className="inv2-legend">
            <span>fill %</span>
            <span className="mono" style={{ fontSize: 11, fontWeight: 500, color: "oklch(0.5 0.03 262)" }}>lo</span>
            <span className="mono" style={{ fontSize: 13.5, fontWeight: 600, color: "oklch(0.4 0.09 262)" }}>mid</span>
            <span className="mono" style={{ fontSize: 16, fontWeight: 700, color: "oklch(0.28 0.14 262)" }}>hi</span>
            <span style={{ marginLeft: 6 }}>·&nbsp;= empty</span>
          </div>
        </div>
      )}

      {/* sticky source header */}
      {cardView !== "others" && (
        <div className="inv2-srchead">
          <div className="inv2-srcgrid" style={{ gridTemplateColumns: srcCols }}>
            <div className="col-label">POSITION</div>
            <div></div>
            {displayBrands.map((b) => (
              <div className="src" key={`src-${b.value}`} title={b.label}>{b.label}</div>
            ))}
            <div className="src total-col" title="Slot total (all sources)">Total</div>
          </div>
        </div>
      )}
      {loader ? (
        <div style={{ padding: "60px 0", textAlign: "center", color: "oklch(0.55 0.02 260)" }}>Loading…</div>
      ) : !filteredData.length ? (
        <div style={{ padding: "60px 0", textAlign: "center", color: "oklch(0.55 0.02 260)" }}>No Data Found</div>
      ) : (
        <>
          {filteredData.map((item, index) => {
            const d = derive(item);
            return (
              <div className="inv2-card" key={`card-${index}`}>
                <div className="grid2">
                  {/* left rail: position summary */}
                  <div className="rail">
                    <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}>
                      <div className="flex items-baseline gap-2">
                        <span className="pos-num mono">{item.position}</span>
                        <span className="pos-cap">pos</span>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div className="r-lbl">Total</div>
                        <div className="r-val mono" title={d.total}>{formatSpentValue(d.total)}</div>
                      </div>
                    </div>
                    <div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 3 }}>
                        <span className="mono" style={{ fontSize: 14, fontWeight: 700, color: "oklch(0.5 0.13 155)" }}>{d.occPct.toFixed(1)}%</span>
                        <span style={{ fontSize: 10.5, color: "oklch(0.6 0.01 260)" }}>occupied</span>
                      </div>
                      <div className="bar"><span style={{ width: `${Math.min(100, d.occPct)}%` }}></span></div>
                      <div className="mono" style={{ display: "flex", justifyContent: "space-between", marginTop: 4, fontSize: 11.5 }}>
                        <span style={{ color: "oklch(0.55 0.06 155)" }} title={d.occupied}>{formatSpentValue(d.occupied)} occ</span>
                        <span style={{ color: "oklch(0.6 0.13 45)" }} title={d.unoccupied}>{formatSpentValue(d.unoccupied)} unocc {pctOf(d.unoccupied, d.total)}%</span>
                      </div>
                    </div>
                  </div>

                  {/* right: heatmap + funnel */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {cardView !== "others" && (
                    <div className="heat" style={{ gridTemplateColumns: heatCols }}>
                      {[0, 1, 2].map((slotIndex) => {
                        const slotData = d.team_stats[slotIndex] || [];
                        return (
                          <React.Fragment key={`slot-${slotIndex}`}>
                            <div className="slot">{slotOptions[slotIndex]}</div>
                            {displayBrands.map((brand) => {
                              const imps = +(slotData.find((i) => +i.new_user_type === +brand.value)?.imprs) || 0;
                              const pct = imps ? (imps / d.total) * 100 : 0;
                              const ht = heatText(pct);
                              const zero = !imps;
                              return (
                                <div
                                  key={`c-${brand.value}-${slotIndex}`}
                                  className={`cell ${zero ? "" : "clk"}`}
                                  title={`${brand.label}: ${imps}${pct > 0 ? ` (${pct.toFixed(1)}%)` : ""}`}
                                  onClick={() => {
                                    if (!zero)
                                      fetchAdsData({ position: item.position, new_user_type: brand.value, slot: slotIndex });
                                  }}
                                >
                                  {zero ? (
                                    <span className="dot">·</span>
                                  ) : (
                                    <>
                                      <span className="lab mono" style={{ fontSize: ht.size, fontWeight: ht.weight, color: ht.color }}>{formatSpentValue(imps)}</span>
                                      {pct > 0 && <span className="pct mono">{pct.toFixed(1)}%</span>}
                                    </>
                                  )}
                                </div>
                              );
                            })}
                            {(() => {
                              const rowTot = displayBrands.reduce(
                                (a, brand) => a + (+(slotData.find((i) => +i.new_user_type === +brand.value)?.imprs) || 0),
                                0
                              );
                              const pct = rowTot ? (rowTot / d.total) * 100 : 0;
                              const zero = !rowTot;
                              return (
                                <div className="cell total" title={`${slotOptions[slotIndex]} total: ${rowTot}${pct > 0 ? ` (${pct.toFixed(1)}%)` : ""}`}>
                                  {zero ? (
                                    <span className="dot">·</span>
                                  ) : (
                                    <>
                                      <span className="lab mono">{formatSpentValue(rowTot)}</span>
                                      {pct > 0 && <span className="pct mono">{pct.toFixed(1)}%</span>}
                                    </>
                                  )}
                                </div>
                              );
                            })()}
                          </React.Fragment>
                        );
                      })}
                    </div>
                    )}

                    {cardView !== "slot" && (
                    <div className="funnel">
                      {/* DFP Occupied */}
                      <div>
                        <div className="f-head fh-dfp">DFP Occupied</div>
                        <div className="f-cells" style={{ gridTemplateColumns: "repeat(4,1fr)" }}>
                          <div>
                            <div className="f-lbl">Requests</div>
                            <div className="f-val clk mono" title={d.dfp_reqs} onClick={() => fetchDFPInternalData({ position: item.position, ad_type: "request" })}>{formatSpentValue(d.dfp_reqs)}</div>
                          </div>
                          <div>
                            <div className="f-lbl">Displays</div>
                            <div className="f-val clk violet mono" title={d.dfp_imprs} onClick={() => fetchDFPInternalData({ position: item.position, ad_type: "display" })}>{formatSpentValue(d.dfp_imprs)} <span className="sm">{pctOf(d.dfp_imprs, d.total)}%</span></div>
                          </div>
                          <div>
                            <div className="f-lbl">No-Fill Err</div>
                            <div className="f-val clk orange mono" title={d.dfp_no_fill} onClick={() => fetchDFPNofillOtherData({ position: item.position, error_type: "no_fill" })}>{formatSpentValue(d.dfp_no_fill)}</div>
                          </div>
                          <div>
                            <div className="f-lbl">Other Err</div>
                            <div className="f-val clk rederr mono" title={d.dfp_other} onClick={() => fetchDFPNofillOtherData({ position: item.position, error_type: "other_error" })}>{formatSpentValue(d.dfp_other)}</div>
                          </div>
                        </div>
                      </div>
                      {/* GAM Occupied */}
                      <div>
                        <div className="f-head fh-gam">GAM Occupied</div>
                        <div className="f-cells" style={{ gridTemplateColumns: "repeat(5,1fr)" }}>
                          <div>
                            <div className="f-lbl">Requests</div>
                            <div className="f-val clk mono" title={d.net_requests} onClick={() => getNetadcodeWiseStats({ ad_type: "request", position: item.position })}>{formatSpentValue(d.net_requests)}</div>
                          </div>
                          <div>
                            <div className="f-lbl">Responses</div>
                            <div className="f-val clk mono" title={d.net_responses} onClick={() => getNetadcodeWiseStats({ ad_type: "response", position: item.position })}>{formatSpentValue(d.net_responses)}</div>
                          </div>
                          <div>
                            <div className="f-lbl">Display</div>
                            <div className="f-val clk violet mono" title={d.net_displays} onClick={() => getNetadcodeWiseStats({ ad_type: "display", position: item.position })}>{formatSpentValue(d.net_displays)} <span className="sm">{pctOf(d.net_displays, d.total)}%</span></div>
                          </div>
                          <div>
                            <div className="f-lbl">No Fills</div>
                            <div className="f-val clk orange mono" title={d.net_no_fill} onClick={() => getNoFillOtherWiseStats({ error_type: "no_fill", position: item.position })}>{formatSpentValue(d.net_no_fill)}</div>
                          </div>
                          <div>
                            <div className="f-lbl">Other Err</div>
                            <div className="f-val clk rederr mono" title={d.net_other} onClick={() => getNoFillOtherWiseStats({ error_type: "other_error", position: item.position })}>{formatSpentValue(d.net_other)}</div>
                          </div>
                        </div>
                      </div>
                      {/* Ad Partners */}
                      <div>
                        <div className="f-head fh-ap">Ad Partners</div>
                        <div>
                          <div className="f-lbl">Occupied</div>
                          <div className="f-val mono" title={d.ad_partner}>{formatSpentValue(d.ad_partner)}</div>
                        </div>
                      </div>
                      {/* Backfill / Widgets */}
                      <div>
                        <div className="f-head fh-bf">Backfill / Widgets</div>
                        <div className="f-cells" style={{ gridTemplateColumns: `repeat(${(backfillCompanies.length || 1) + 2}, 1fr)` }}>
                          {backfillCompanies.length ? (
                            backfillCompanies.map((c) => {
                              const compStat = (item.backfill_stats || []).find((b) => b.company_id === c.company_id);
                              const compImprs = +compStat?.imprs || 0;
                              return (
                                <div key={`bf-${c.company_id}`}>
                                  <div className="f-lbl" title={c.company_name}>{c.company_name}</div>
                                  <div className={`f-val purple mono ${compStat ? "clk" : ""}`} title={`${c.company_name}: ${compImprs}`} onClick={() => { if (compStat) fetchAdsData({ position: item.position, new_user_type: -1, slot: 3, company_id: c.company_id }); }}>{formatSpentValue(compImprs)} <span className="sm">{pctOf(compImprs, d.total)}%</span></div>
                                </div>
                              );
                            })
                          ) : (
                            <div>
                              <div className="f-lbl">Backfill</div>
                              <div className="f-val purple mono" title={d.backfill}>{formatSpentValue(d.backfill)} <span className="sm">{pctOf(d.backfill, d.total)}%</span></div>
                            </div>
                          )}
                          <div>
                            <div className="f-lbl">Widgets</div>
                            <div className="f-val mono" title={d.widget}>{formatSpentValue(d.widget)} <span className="sm">{pctOf(d.widget, d.total)}%</span></div>
                          </div>
                          <div>
                            <div className="f-lbl">Classified</div>
                            <div className="f-val mono" title={d.classified}>{formatSpentValue(d.classified)} <span className="sm">{pctOf(d.classified, d.total)}%</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

          {/* Totals card — mirrors an individual position card */}
          <div className="inv2-card inv2-total-card">
            <div className="grid2">
              {/* left rail */}
              <div className="rail">
                <div>
                  <div className="r-lbl">Total</div>
                  <div className="r-val mono" title={grand.total}>{formatSpentValue(grand.total)}</div>
                </div>
                <div className="mono" style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5 }}>
                  <span style={{ color: "oklch(0.78 0.09 155)" }} title={grand.occupied}>{formatSpentValue(grand.occupied)} occ {grand.occPct}%</span>
                  <span style={{ color: "oklch(0.78 0.13 45)" }} title={grand.unoccupied}>{formatSpentValue(grand.unoccupied)} unocc {grand.unoccPct}%</span>
                </div>
              </div>

              {/* right: source totals row + funnel totals */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                {cardView !== "others" && (
                <div className="heat" style={{ gridTemplateColumns: heatCols }}>
                  <div className="slot">Σ</div>
                  {displayBrands.map((brand) => {
                    const imps = +grand.brandTotals[brand.value] || 0;
                    const pct = imps ? (imps / grand.total) * 100 : 0;
                    const ht = heatText(pct);
                    const zero = !imps;
                    return (
                      <div
                        key={`tc-${brand.value}`}
                        className="cell"
                        title={`${brand.label}: ${imps}${pct > 0 ? ` (${pct.toFixed(1)}%)` : ""}`}
                      >
                        <span className="src-lab">{brand.label}</span>
                        {zero ? (
                          <span className="dot">·</span>
                        ) : (
                          <>
                            <span className="lab mono" style={{ fontSize: ht.size, fontWeight: ht.weight, color: ht.color }}>{formatSpentValue(imps)}</span>
                            {pct > 0 && <span className="pct mono">{pct.toFixed(1)}%</span>}
                          </>
                        )}
                      </div>
                    );
                  })}
                  {(() => {
                    const pct = grand.direct ? (grand.direct / grand.total) * 100 : 0;
                    return (
                      <div className="cell total" title={`Total: ${grand.direct}${pct > 0 ? ` (${pct.toFixed(1)}%)` : ""}`}>
                        <span className="src-lab">Total</span>
                        {!grand.direct ? (
                          <span className="dot">·</span>
                        ) : (
                          <>
                            <span className="lab mono">{formatSpentValue(grand.direct)}</span>
                            {pct > 0 && <span className="pct mono">{pct.toFixed(1)}%</span>}
                          </>
                        )}
                      </div>
                    );
                  })()}
                </div>
                )}

                {cardView !== "slot" && (
                <div className="funnel">
                  {/* DFP Occupied */}
                  <div>
                    <div className="f-head fh-dfp">DFP Occupied</div>
                    <div className="f-cells" style={{ gridTemplateColumns: "repeat(4,1fr)" }}>
                      <div>
                        <div className="f-lbl">Requests</div>
                        <div className="f-val mono" title={grand.dfp_reqs}>{formatSpentValue(grand.dfp_reqs)}</div>
                      </div>
                      <div>
                        <div className="f-lbl">Displays</div>
                        <div className="f-val violet mono" title={grand.dfp_imprs}>{formatSpentValue(grand.dfp_imprs)} <span className="sm">{pctOf(grand.dfp_imprs, grand.total)}%</span></div>
                      </div>
                      <div>
                        <div className="f-lbl">No-Fill Err</div>
                        <div className="f-val orange mono" title={grand.dfp_no_fill}>{formatSpentValue(grand.dfp_no_fill)}</div>
                      </div>
                      <div>
                        <div className="f-lbl">Other Err</div>
                        <div className="f-val rederr mono" title={grand.dfp_other}>{formatSpentValue(grand.dfp_other)}</div>
                      </div>
                    </div>
                  </div>
                  {/* GAM Occupied */}
                  <div>
                    <div className="f-head fh-gam">GAM Occupied</div>
                    <div className="f-cells" style={{ gridTemplateColumns: "repeat(5,1fr)" }}>
                      <div>
                        <div className="f-lbl">Requests</div>
                        <div className="f-val mono" title={grand.net_requests}>{formatSpentValue(grand.net_requests)}</div>
                      </div>
                      <div>
                        <div className="f-lbl">Responses</div>
                        <div className="f-val mono" title={grand.net_responses}>{formatSpentValue(grand.net_responses)}</div>
                      </div>
                      <div>
                        <div className="f-lbl">Display</div>
                        <div className="f-val violet mono" title={grand.net_displays}>{formatSpentValue(grand.net_displays)} <span className="sm">{pctOf(grand.net_displays, grand.total)}%</span></div>
                      </div>
                      <div>
                        <div className="f-lbl">No Fills</div>
                        <div className="f-val orange mono" title={grand.net_no_fill}>{formatSpentValue(grand.net_no_fill)}</div>
                      </div>
                      <div>
                        <div className="f-lbl">Other Err</div>
                        <div className="f-val rederr mono" title={grand.net_other}>{formatSpentValue(grand.net_other)}</div>
                      </div>
                    </div>
                  </div>
                  {/* Ad Partners */}
                  <div>
                    <div className="f-head fh-ap">Ad Partners</div>
                    <div>
                      <div className="f-lbl">Occupied</div>
                      <div className="f-val mono" title={grand.ad_partner}>{formatSpentValue(grand.ad_partner)}</div>
                    </div>
                  </div>
                  {/* Backfill / Widgets */}
                  <div>
                    <div className="f-head fh-bf">Backfill / Widgets</div>
                    <div className="f-cells" style={{ gridTemplateColumns: `repeat(${(backfillCompanies.length || 1) + 2}, 1fr)` }}>
                      {backfillCompanies.length ? (
                        backfillCompanies.map((c) => (
                          <div key={`bft-${c.company_id}`}>
                            <div className="f-lbl" title={c.company_name}>{c.company_name}</div>
                            <div className="f-val purple mono" title={`${c.company_name}: ${grand.backfillByCompany[c.company_id] || 0}`}>{formatSpentValue(grand.backfillByCompany[c.company_id] || 0)} <span className="sm">{pctOf(grand.backfillByCompany[c.company_id] || 0, grand.total)}%</span></div>
                          </div>
                        ))
                      ) : (
                        <div>
                          <div className="f-lbl">Backfill</div>
                          <div className="f-val purple mono" title={grand.backfill}>{formatSpentValue(grand.backfill)} <span className="sm">{pctOf(grand.backfill, grand.total)}%</span></div>
                        </div>
                      )}
                      <div>
                        <div className="f-lbl">Widgets</div>
                        <div className="f-val mono" title={grand.widget}>{formatSpentValue(grand.widget)} <span className="sm">{pctOf(grand.widget, grand.total)}%</span></div>
                      </div>
                      <div>
                        <div className="f-lbl">Classified</div>
                        <div className="f-val mono" title={grand.classified}>{formatSpentValue(grand.classified)} <span className="sm">{pctOf(grand.classified, grand.total)}%</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      </div>
      {adsdata?.length ? (
        <div
          className="inventory-ad-view"
          onClick={() => {
            setAdsData([]);
          }}
        >
          <div className="popupview" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={() => {
                setAdsData([]);
                setShowPreview(false);
                setPreview({});
                setPreviewIndex(-1);
              }}
            >
              <img src={closeSvg} alt="close2" />
            </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Language:{" "}
                <span>
                  {langNames[selectedLanguage] || "All"}
                </span>
              </h5>
              <h5>
                Position: <span>{adsdata[0]?.position}</span>
              </h5>
              <h5>
                Impressions: <span>{formatSpentValue(adsdata.reduce((acc, item) => acc + +item.imprs, 0))}</span>
              </h5>
            </div>
            <div className="over-flow-view flex gap-3 ">
              <div className="w-1/2">
                <table
                  className="table table-bordered table-impress"
                  style={{ width: "100%", margin: "auto" }}
                >
                  <thead className="">
                    <tr>
                      <th>Campaign Name</th>
                      <th>Impressions</th>
                      <th>Creative</th>
                    </tr>
                  </thead>
                  {adsdata.length && !loader ? (
                    <tbody>
                      {adsdata.map((item, index) => (
                        <tr
                          key={index}
                          className={`${
                            previewIndex === index ? "bg-yellow-100" : ""
                          }`}
                        >
                          <td>{item.campaign_name}</td>
                          <td title={item.imprs}>
                            {formatSpentValue(item.imprs)}
                          </td>
                          <td>
                            {
                              <SlIcon
                                name="eye"
                                library="lucide"
                                onClick={() => {
                                  fetchPreview(item);
                                  setPreviewIndex(index);
                                }}
                              />
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : !data.length && !loader ? (
                    <NoDataFound
                      colspan={(5 + BrandsTypes.length + 1) * languages.length}
                    />
                  ) : (
                    <TableLoader
                      colspan={(5 + BrandsTypes.length + 1) * languages.length}
                    />
                  )}
                </table>
              </div>
              <div className="w-1/2">
                <InventoryContext.Provider value={{ preview, setPreview }}>
                  <PreviewFrameEdit showPreview={showPreview} />
                </InventoryContext.Provider>{console.log(preview)}
                {preview?.target_details && Object.keys(preview?.target_details)?.length ? <section className="bg-slate-50 py-4 px-6 rounded-lg mt-2">
                    <h6 className="mb-2">Target</h6>
                    {preview?.actual_target?.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                    {(Array.isArray(preview?.actual_target?.lang_ids) && preview?.actual_target?.lang_ids?.length > 0) && preview?.target_details.lang_ids.map((item, i) => {
                        if (preview?.actual_target?.lang_ids.includes(item))
                            return <span key={i}>{langNames[item]}</span>
                    })}
                    {preview?.target_details?.zone_ids?.length > 0 && <div>
                        {<label className="text-slate-500">Zones : </label>}
                        {preview?.target_details?.zone_ids?.map((item, i) => {
                            return <p key={i}>{item.zone_name}</p>
                        }
                        )}
                    </div>}
                    {!preview?.target_details?.zone_ids?.length ? <>
                    {(Array.isArray(preview?.actual_target?.state_ids) && preview?.actual_target?.state_ids?.length > 0) && (<div>
                        <label className="text-slate-500">States : </label>
                        {preview?.target_details?.state_ids?.filter(stateId => (preview?.target_details?.district_ids?.length === 0 || preview?.target_details?.district_ids?.some(entry => +entry.state_id !== +stateId.state_id))).map((item, i) => {
                            if (preview?.actual_target?.state_ids.includes(item.state_id))
                                return <p>{item.state_name}</p>
                        }
                        )}
                    </div>)}
                    {(!preview?.target_details?.exclude && Array.isArray(preview?.actual_target?.district_ids) && preview?.actual_target?.district_ids?.length > 0) && <div>
                        {<label className="text-slate-500">Districts : </label>}
                        {preview?.target_details?.district_ids?.map((item, i) => {
                            if (preview?.actual_target?.district_ids?.includes(item.dist_id))
                                return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_districts) && preview?.actual_target?.ex_districts?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded Districts : </label>}
                        {preview?.target_details?.district_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_districts?.includes(item.dist_id))
                                return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.target_details?.constituency_ids) && preview?.target_details?.constituency_ids?.length > 0) && <div>
                        {preview?.target_details?.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                        {preview?.target_details?.constituency_ids?.map((item, i) => {
                            return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(!preview?.target_details?.exclude && Array.isArray(preview?.actual_target?.mandal_ids) && preview?.actual_target?.mandal_ids?.length > 0) && <div>
                        {<label className="text-slate-500">Mandals : </label>}
                        {preview?.target_details?.mandal_ids?.map((item, i) => {
                            if (preview?.actual_target?.mandal_ids?.includes(item.mandal_id))
                                return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_mandals) && preview?.actual_target?.ex_mandals?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded Mandals : </label>}
                        {preview?.target_details?.mandal_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_mandals?.includes(item.mandal_id))
                                return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.village_ids) && preview?.actual_target?.village_ids?.length > 0) && <div>
                        {<label className="text-slate-500">villages : </label>}
                        {preview?.target_details?.village_ids?.map((item, i) => {
                            if (preview?.actual_target?.village_ids?.includes(item.village_id))
                                return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    {(Array.isArray(preview?.actual_target?.ex_villages) && preview?.actual_target?.ex_villages?.length > 0) && <div>
                        {<label className="text-slate-500">Excluded villages : </label>}
                        {preview?.target_details?.village_ids?.map((item, i) => {
                            if (preview?.actual_target?.ex_villages?.includes(item.village_id))
                                return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                        }
                        )}
                    </div>}
                    </> : null}
                    {(Array.isArray(preview?.target_details?.app_category) && preview?.target_details?.app_category?.length > 0) && <div>
                        {<label className="text-slate-500">App Category : </label>}
                        {preview?.target_details?.app_category?.map((item, i) => (

                            <p key={i}> {appCategoryNames[item]}</p>
                        )
                        )}
                    </div>}
                    {(Array.isArray(preview?.target_details?.minspend) && preview?.target_details?.minspend?.length > 0) && <div>
                        {<label className="text-slate-500">Minimum Spend : </label>}
                        {preview?.target_details?.minspend?.map((item, i) => (

                            <p key={i}>{item}</p>
                        )
                        )}
                    </div>}
                    {preview?.target_details ? <div>
                        {preview?.target_details?.min_age > 0 && <p><label className="text-slate-500">Min Age</label> : {preview?.target_details.min_age}</p>}
                        {preview?.target_details?.max_age > 0 && <p><label className="text-slate-500">Max Age</label> : {preview?.target_details.max_age}</p>}
                        {preview?.target_details?.versions?.android_version && <p><label className="text-slate-500">Android Version</label> : {preview?.target_details?.versions?.android_version || ''}</p>}
                        {preview?.target_details?.versions?.ios_version && <p><label className="text-slate-500">IOS Version</label> : {preview?.target_details?.versions?.ios_version || ''}</p>}
                        {preview?.target_details?.os !== '' && <p><label className="text-slate-500">OS</label> : {osNames[preview?.target_details.os]}</p>}
                        {genderNames[preview?.target_details?.gender] !== null && <p><label className="text-slate-500">Gender</label> : {genderNames[preview?.target_details.gender]} </p>}
                    </div> : null}
                </section> : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {netPosView ? (
        <div
          className="inventory-ad-view"
          onClick={() => {
            setNetPosView(null);
            setErrorCodewiseStats(null);
            setPreviewIndex(-1);
          }}
        >
          <div class="popupview" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => {
              setNetPosView(null);
              setErrorCodewiseStats(null);
              setPreviewIndex(-1);
            }}>
              <img src={closeSvg} alt="close2" />
            </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Language:{" "}
                <span className="capitalize">{langNames[netPosView.lang_id] || "All"}</span>
              </h5>
              <h5>
                Position: <span>{netPosView.position}</span>
              </h5>
              <h5>
                Ad Type: <span>{netPosView.ad_type}</span>
              </h5>
              <h5>
                Count: <span>{formatSpentValue(netPosView?.data?.reduce((acc, item) => acc + +item.count, 0))}</span>
              </h5>
            </div>
            <div className="d-flex gap-2">
            <div className="over-flow-view">
              <div className="ad-codes">
                <table className="table table-bordered table-impress">
                  <thead>
                    <tr>
                      <th>Ad Code</th>
                      <th>Count</th>
                      {netPosView.ad_type === 'Other Errors' ?<th>View</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {netPosView?.data?.map((item, index) => (
                      <tr key={index}
                      className={`${
                        previewIndex === index ? "bg-yellow-100" : ""
                      }`}>
                        <td>{item.ad_code}</td>
                        <td>{formatSpentValue(item.count)}</td>
                        {netPosView.ad_type === 'Other Errors' ? <td>
                            {
                              <SlIcon
                                name="eye"
                                library="lucide"
                                onClick={() => {
                                  fetchErrorCodewiseStats({ad_code: item.ad_code, position: netPosView.position, error_type: netPosView.ad_type});
                                  setPreviewIndex(index);
                                }}
                              />
                            }
                          </td> : null}
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>

            {
                  errorCodewiseStats ? (
                    <div className="overflow-y-auto max-h-[600px]">
                      <table className="table table-bordered table-impress">
                        <thead>
                          <tr>
                            <th>Error Code</th>
                            <th>Count</th>
                          </tr>
                      </thead>
                      <tbody>
                        {errorCodewiseStats.map((item, index) => (
                          <tr key={index}>
                            <td className="truncate !max-w-[300px]" title={item.description}>{item.description}</td>
                            <td>{formatSpentValue(item.count)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  ) : null
                }
              </div>
          </div>
        </div>
      ) : null}

      {dfpInternalData?.length ? (
        <div className="inventory-ad-view"
        onClick={() => {
          setDFPInternalData([]);
        }}>
          <div className="popupview" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={() => {
                setDFPInternalData([]);
              }}
            >
            <img src={closeSvg} alt="close2" />
          </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Position: <span>{dfpInternalData[0]?.position}</span>
              </h5>
              <h5>
                {dfpInternalData[0]?.ad_type === "request" ? "Requests" : "Displays"}: <span>{formatSpentValue(dfpInternalData.reduce((acc, item) => acc + +item.imprs, 0))}</span>
              </h5>
            </div>
            <div className="d-flex gap-2">
              <div className="over-flow-view">
                <table className="table table-bordered table-impress">
                  <thead>
                    <tr>
                      <th>Ad Code</th>
                      <th>Impressions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dfpInternalData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.ad_code}</td>
                        <td>{formatSpentValue(item.imprs)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {dfpNofillOtherData?.data?.length ? (
        <div className="inventory-ad-view"
        onClick={() => {
          setDFPNofillOtherData(null);
          setDFPOtherErrorPreviewIndex(-1);
          setDFPOtherErrorPreviewData(null);
        }}>
          <div className="popupview" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => {
              setDFPNofillOtherData(null);
              setDFPOtherErrorPreviewIndex(-1);
              setDFPOtherErrorPreviewData(null);
            }}>
              <img src={closeSvg} alt="close2" />
            </button>
            <div className="d-flex justify-between gap-2">
              <h5>
                Date:
                <span> {dateFilter}</span>
              </h5>
              <h5>
                Position: <span>{dfpNofillOtherData?.position}</span>
              </h5>
              <h5>
                Ad Type: <span>{dfpNofillOtherData?.ad_type}</span>
              </h5>
              <h5>
                Count: <span>{formatSpentValue(dfpNofillOtherData?.data?.reduce((acc, item) => acc + +item.count, 0))}</span>
              </h5>
            </div>
            <div className="d-flex gap-2">
              <div className="over-flow-view">
              <div className="ad-codes">
                <table className="table table-bordered table-impress">
                  <thead>
                    <tr>
                      <th>Error Code</th>
                      <th>Count</th>
                      {dfpNofillOtherData?.ad_type === 'Other Errors' ? <th>Actions</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {dfpNofillOtherData?.data?.map((item, index) => (
                      <tr key={index} className={`${
                        dfpotherErrorPreviewIndex === index ? "bg-yellow-100" : ""
                      }`}>
                        <td>{item.ad_code}</td>
                        <td>{formatSpentValue(item.count)}</td>
                        {dfpNofillOtherData?.ad_type === 'Other Errors' ? <td>
                          <SlIcon
                            name="eye"
                            library="lucide"
                            onClick={() => {
                              fetchDFPOtherErrorWiseStats({ad_code: item.ad_code, position: dfpNofillOtherData.position});
                              setDFPOtherErrorPreviewIndex(index);
                            }}
                          />
                        </td> : null}
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                </div>
                {dfpotherErrorPreviewData ? (
                  <div className="overflow-y-auto max-h-[600px]">
                      <table className="table table-bordered table-impress">
                        <thead>
                        <tr>
                          <th>Description</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                    <tbody>
                      {dfpotherErrorPreviewData.map((item, index) => (
                        <tr key={index}>
                          <td className="truncate !max-w-[300px]" title={item.description}>{item.description}</td>
                          <td>{formatSpentValue(item.count)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                ) : null}              
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Inventory;
